import type { FaireProductEntity } from "../../entity_types/product";

export const p_gfvyvnv75m: FaireProductEntity = {
  token: "p_gfvyvnv75m",
  type: "product",
  name: "Knit Open Front Bishop Sleeves Pockets Cardigan",
  brandToken: "b_ssnpnu4tp4",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/fc500dcc9a6378f8d5abccb6655e7fec6f70c803a33777594dba025e9c44d96e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/453979f71edd11f682e4cbfd2f8747593d51ee31062e3eb321d10a70f32f1a90.jpeg",
    "https://cdn.faire.com/fastly/2cdfc8e051499dda3c7ef0e3775200ae7ced8573aacc3c8dd300fbb363f8e9cc.jpeg",
    "https://cdn.faire.com/fastly/7de2b6fed0aa12d2a0e3445ad40837130b68abf7f87fb746b36efc73c84a7010.jpeg",
    "https://cdn.faire.com/fastly/822b8926da4090e18062809509b193a51cd01a564351bc081dc28c38d875425b.jpeg",
    "https://cdn.faire.com/fastly/3330e8b46ba12bfc292b704e6edb2c005b949126eb197089578a0c5a9f2884e8.jpeg",
    "https://cdn.faire.com/fastly/0c821eeab427beec1289f83e94078168b8a347d4287cfc77b741c5a4170c6948.jpeg",
    "https://cdn.faire.com/fastly/75ad863579ba2cc98c0349a59d8309a3c2024b94578ed12032e07a6dede827dc.jpeg",
    "https://cdn.faire.com/fastly/30b599183b08202e0e62e264a91f1f75a2ffddd27eb2af40a52d0b5be2f14c6a.jpeg",
    "https://cdn.faire.com/fastly/73f6d32852ba879190de8b8c19db8783874d283c58edb1548a3da4546a05700e.jpeg",
  ],
  priceDollars: 41.57,
  description:
    "Material: 50% Acrylic 22% Polyamide 28% Polyester\nFeatures: Knit Open Front Bishop Sleeves Pockets Cardigan\nOccasion: Casual/ Daily/Outdoor/Vacation/School/Going Out.\nStyle # EDCT570718\n",
  tags: [],
  msrpDollars: 83.13,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:42.419Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
